/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectFormatDdl { 
    /**
     * The Namespace to which a Business Object Format is related
     */
    namespace: string;
    /**
     * The name of the Business Object Definition to which a Business Object Format is related
     */
    businessObjectDefinitionName: string;
    /**
     * The Usage of this Business Object Format - a string describing how this format is used. Often used as a label for the Business                   Object Format. Does not have to be unique in the system, the Usage string is frequently shared across formats for multiple Business Object                   Definitions                
     */
    businessObjectFormatUsage: string;
    /**
     * A File Type known to the system that describes the file type of data stored under a Business Object Format
     */
    businessObjectFormatFileType: string;
    /**
     * The numeric version of a Business Object Format. If not supplied, the latest version will be used
     */
    businessObjectFormatVersion?: number;
    /**
     * The output format for the generated DDL. The only format currently supported is HIVE_13_DDL
     */
    outputFormat: BusinessObjectFormatDdl.OutputFormatEnum;
    /**
     * The table name to be used in the generated DDL
     */
    tableName: string;
    /**
     * he name of the Custom DDL. When Custom DDL name is specified, the Custom DDL which had previously been stored Business Object                   Format is returned instead of generated DDL. Must not be specified when replaceColumns is true                
     */
    customDdlName?: string;
    /**
     * A container for the generated DDL code which contains DDL for all the objects in the collection
     */
    ddl: string;
}
export namespace BusinessObjectFormatDdl {
    export type OutputFormatEnum = 'HIVE_13_DDL';
    export const OutputFormatEnum = {
        HIVE13DDL: 'HIVE_13_DDL' as OutputFormatEnum
    };
}
